import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { mainUrl } from "../../api/client/api"

const Blogs = () => {
    const [blogs, setBlogs] = useState([]);
    useEffect(() => { window.scrollTo(0, 0); fetchBlogs(); }, []);

    const fetchBlogs = async () => {
        try {
            const res = await axios.get(`${mainUrl}api/blog/get-all-blog`);
            if (res?.data?.status) { setBlogs(res.data.data || []) };
        }
        catch (error) { console.log("BLOG LIST ERROR:", error); }
    };

    const limitWords = (text, maxWords = 25) => {
        if (!text) return "";
        const words = text?.split(" ");
        return words?.length > maxWords ? words?.slice(0, maxWords).join(" ") + "..." : text;
    };

    return (
        <section className="content-section">
            <div className="container">
                <h1>RROOMS Blogs</h1>
                <div className="blog-grid" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: "25px", marginTop: "35px", marginBottom: "35px" }}>
                    {blogs.map((item) => (
                        <div style={{ background: "#fff", borderRadius: "10px", overflow: "hidden", border: "2px solid #ddcdcd", boxShadow: "rgb(0 0 0 / 40%) 0px 2px 6px", padding: "10px", transition: "0.2s" }}>
                            <img src={mainUrl + item?.blogImg} alt={item?.imgAlt} title={item?.blogTitle} style={{ width: "100%", height: "160px", objectFit: "cover" }} />
                            <h3 style={{ padding: "12px", fontSize: "18px", borderTop: "2px solid #cfcccc" }}>{limitWords(item?.blogHeading, 5)}</h3>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "0 12px" }}>
                                <span style={{ fontSize: "14px", color: "#666", fontWeight: '600' }}>Created On :{" "}
                                    {new Date(item?.createdAt).toLocaleDateString("en-IN", { year: "numeric", month: "short", day: "numeric" })}
                                </span>
                                <Link key={item?.id} to={`/blog-details/${item?.id}`} className="btn btn-sm btn-primary" style={{ textDecoration: "none", color: "#fff" }}>
                                    View
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Blogs;
